import type { EntryPoint } from '@/apilib';
import { EditorAPIKey, MouseActionsApiKey } from '@/apis';
import { createMouseActionsApi } from './mouseActionsWrapper';

export const MouseActionsEntrypoint: EntryPoint = {
  name: 'MouseActionsApi',
  declareAPIs: () => [MouseActionsApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(MouseActionsApiKey, () => createMouseActionsApi(shell));
  },
};
